import { render, staticRenderFns } from "./AddLesson.vue?vue&type=template&id=5d6e2a1a&scoped=true&"
import script from "./AddLesson.vue?vue&type=script&lang=js&"
export * from "./AddLesson.vue?vue&type=script&lang=js&"
import style0 from "./AddLesson.vue?vue&type=style&index=0&id=5d6e2a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e2a1a",
  null
  
)

export default component.exports